import React, { useState } from "react";
import { db } from "../firebaseConfig";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import "./ecertificate.css";
import { FaCheck } from "react-icons/fa";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";

const ECertificateRequestPage = () => {
  const [form, setForm] = useState({
    fullName: "",
    position: "",
    organization: "",
    email: "",
    phone: "",
    feedback: "", // <-- NEW FIELD
  });

  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e: any) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setError("");

    if (
      !form.fullName ||
      !form.position ||
      !form.organization ||
      !form.email ||
      !form.phone ||
      !isValidPhoneNumber(form.phone) ||
      !form.feedback.trim()
    ) {
      setError("Please fill in all required fields including feedback.");
      return;
    }

    try {
      setSubmitting(true);

      await addDoc(collection(db, "ecertificate_requests"), {
        fullName: form.fullName,
        position: form.position,
        organization: form.organization,
        email: form.email.toLowerCase(),
        phone: form.phone,
        feedback: form.feedback.trim(), // <-- SAVE FEEDBACK
        status: "pending",
        createdAt: serverTimestamp(),
      });
      await fetch(
        "https://us-central1-icaconference-438ba.cloudfunctions.net/sendECertRequestNotification",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            fullName: form.fullName,
            position: form.position,
            organization: form.organization,
            email: form.email,
            phone: form.phone,
            feedback: form.feedback,
          }),
        }
      );

      setSubmitted(true);
    } catch (err) {
      console.error(err);
      setError("Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="ecert-page">
      <div className="ecert-hero-section">
        <div
          className="ecert-hero-left"
          style={{
            backgroundImage:
              "url('https://res.cloudinary.com/astcdubai/image/upload/v1763977622/F39A4939_e9wj6y.jpg')",
          }}
        ></div>

        <div className="ecert-hero-right">
          {!submitted ? (
            <div className="ecert-right-content">
              <h1 className="ecert-hero-title">E-Certificate Request</h1>
              <p className="ecert-hero-sub">
                Please complete the form below to request your official ICA
                e-Certificate.
              </p>

              <div className="ecert-card" style={{ padding: "2rem" }}>
                {/* ====================== FORM ====================== */}
                <form onSubmit={handleSubmit} className="space-y-6">
                  <div>
                    <label className="ecert-label">Full Name</label>
                    <input
                      type="text"
                      name="fullName"
                      className="ecert-input"
                      value={form.fullName}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div>
                    <label className="ecert-label">Position</label>
                    <input
                      type="text"
                      name="position"
                      className="ecert-input"
                      value={form.position}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div>
                    <label className="ecert-label">Organization</label>
                    <input
                      type="text"
                      name="organization"
                      className="ecert-input"
                      value={form.organization}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div>
                    <label className="ecert-label">Email Address</label>
                    <input
                      type="email"
                      name="email"
                      className="ecert-input"
                      value={form.email}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div>
                    <label className="ecert-label">Mobile Number</label>
                    <div
                      className={`phone-wrapper ${
                        (!form.phone || !isValidPhoneNumber(form.phone)) &&
                        error
                          ? "phone-error"
                          : ""
                      }`}
                    >
                      <PhoneInput
                        placeholder="Mobile Number (e.g. +971 xx xxx xxxx)"
                        value={form.phone}
                        international
                        defaultCountry="AE"
                        onChange={(val) =>
                          setForm({ ...form, phone: val || "" })
                        }
                      />
                    </div>
                  </div>

                  {/* ====================== FEEDBACK TEXTAREA ====================== */}
                  <div style={{ marginTop: 20 }}>
                    <label className="ecert-label">
                      We would like to hear your feedback:
                    </label>
                    <textarea
                      name="feedback"
                      placeholder="Please share any comments or suggestions about your experience at the 48th ICA Conference"
                      className="ecert-input"
                      style={{
                        minHeight: "120px",
                        resize: "vertical",
                      }}
                      value={form.feedback}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  {error && (
                    <div
                      className="ecert-error"
                      style={{ paddingTop: 10, fontStyle: "italic" }}
                    >
                      {error}
                    </div>
                  )}

                  <button
                    type="submit"
                    disabled={submitting}
                    className="ecert-back-btn"
                  >
                    {submitting ? "Submitting..." : "Submit Request"}
                  </button>
                </form>
              </div>
            </div>
          ) : (
            /* ====================== THANK YOU SCREEN ====================== */
            <div className="ecert-thankyou-wrapper">
              <div className="ecert-thankyou-card">
                <div className="ecert-success-checkmark">
                  <FaCheck size={45} />
                </div>

                <h2>REQUEST SUBMITTED</h2>
                <p>
                  Thank you! We will validate your attendance and send your
                  e-Certificate once approved.
                </p>

                <button
                  className="ecert-back-btn"
                  onClick={() => window.location.reload()}
                >
                  Back to Request Page
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ECertificateRequestPage;
